import { classSet } from '@platform/ui-library';
import { FC, ReactNode } from 'react';
import { Label } from '../label';
import styles from './form-field.module.scss';

/** Wrapper for form component with standard CSS, and options. */
export type FormFieldProps = {
  children: ReactNode;
  className?: string;
  label: string;
  size?: 'small';
  tooltip?: string;
};

export const FormField: FC<FormFieldProps> = ({
  className,
  children,
  label,
  size,
  tooltip
}) => {
  className = classSet([
    styles.formField,
    (size) ? styles[size] : null,
    className
  ]);
  return (
    <div className={className}>
      <Label tooltip={tooltip}>{label}</Label>
      <div>
        {children}
      </div>
    </div>
  );
};
